"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const typed_primitives_1 = require("@sixfold/typed-primitives");
const react_1 = require("react");
const error_context_1 = require("./error_context");
class ErrorBoundary extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.state = { capturedError: null };
    }
    static getDerivedStateFromError(error) {
        return { capturedError: error };
    }
    componentDidCatch(error, errorInfo) {
        this.context?.captureError(new typed_primitives_1.CustomError(error.message, { metadata: { info: errorInfo, stack: error.stack } }), {
            tags: {
                source: 'errorBoundary',
            },
        });
    }
    render() {
        const { children, renderError } = this.props;
        const { capturedError } = this.state;
        if (capturedError !== null) {
            return renderError(capturedError);
        }
        return children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
ErrorBoundary.contextType = error_context_1.ErrorContext;
//# sourceMappingURL=error_boundary.js.map